import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import type { Company } from "../../store/admin/companiesStore";

export interface CompanyListParams {
  page?: number;
  limit?: number;
  status?: string;
  name?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface CompanyListBody {
  data?: Company[];
  meta?: ListMeta;
}

export interface CompanyListResult {
  data: Company[];
  meta?: ListMeta;
}

export function useCompaniesList(params: CompanyListParams = {}) {
  return useQuery({
    queryKey: qk.companies.list(params),
    queryFn: ({ signal }) =>
      getJson<CompanyListBody>(
        "/companyList",
        { page: 1, limit: 8, ...params },
        { signal },
      ).then((body) => ({ data: body.data ?? [], meta: body.meta })),
  });
}
